import Geocode from 'react-geocode'
import { GeocodeResponse } from './types'

Geocode.setApiKey(process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? '')
Geocode.setLanguage('cs')
Geocode.setRegion('CZ')

export const getGeocode = async (address: string): Promise<GeocodeResponse | undefined> => {
    const result = await Geocode.fromAddress(address)
    if (result && result.results[0] && result.results[0].geometry.location)
        return {
            lat: Number(result.results[0].geometry.location.lat),
            lng: Number(result.results[0].geometry.location.lng),
        }
}
